import { Anchor, AppShellFooter, Box, Container, Flex, Group, Stack, Text } from '@mantine/core'
import { KnockLogo, KnockNMLSIDIcon } from '@phoenix-web/icons-images'
import {
  COPYRIGHT,
  FOOTER_COMPANY,
  FOOTER_EQUAL_HOUSING,
  FOOTER_LEGAL_STATEMENT_ARR,
  FOOTER_LINKS,
  KNOCK_LENDING_NMLS,
} from '../../constants'
import styles from './StagingFooter.module.css'

export default function StagingFooter({ frontyardUrl }: { frontyardUrl: string }) {
  return (
    <AppShellFooter className={styles.footer_shell} withBorder={false}>
      <Box className={styles.footer_wrapper}>
        <Container size="lg">
          {/* START: Top Section of Footer */}
          <Group className={styles.footer_logo_and_links}>
            <Anchor href={frontyardUrl} aria-label="Go back to home page">
              <KnockLogo height="24px" />
            </Anchor>
            <Flex className={styles.footer_content_links}>
              {FOOTER_LINKS.map(({ link, label, target }) => (
                <Anchor href={frontyardUrl + link} target={target} key={label} className={styles.footer_link}>
                  {label}
                </Anchor>
              ))}
            </Flex>
          </Group>
          {/* END: Top Section of Footer */}
          {/* START: Bottom Section of Footer */}
          <Stack pt="xl">
            {/* Section: Address and Phone */}
            <Text size="sm">{FOOTER_COMPANY}</Text>

            {/* Section: Equal Housing, NMLS ID, & Copyright */}
            <Group py="md" gap="xxl">
              <Text c="black" size="sm">
                <Box pr="xs" display="inline-block" component="span" style={{ verticalAlign: 'middle' }}>
                  <KnockNMLSIDIcon />
                </Box>
                <span>{FOOTER_EQUAL_HOUSING}</span>
              </Text>
              <Text size="sm">{KNOCK_LENDING_NMLS}</Text>
              <Text c="black" size="sm">
                {COPYRIGHT}
              </Text>
            </Group>

            {/* Section: Legal Statements */}
            <Stack c="black" className={styles.footer_sub_text}>
              {FOOTER_LEGAL_STATEMENT_ARR.map((str) => (
                <Text size="sm" key={str}>
                  {str}
                </Text>
              ))}
            </Stack>
            <Box size="sm" className={styles.footer_sub_text}>
              Knock Lending, LLC holds mortgage lending{' '}
              <Anchor size="sm" href={frontyardUrl + '/licenses'} target="_blank" className="simple-link">
                licenses
              </Anchor>{' '}
              in multiple states.
            </Box>
          </Stack>
        </Container>
      </Box>
    </AppShellFooter>
  )
}
